import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DesignServicesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"design_services"}/>
}
